export { default } from './styled';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/styled/index.js
// module id = 849
// module chunks = 121